import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { Field } from "vant";
import { Popup } from "vant";
import { Toast } from "vant";
import { List } from "vant";
import { PullRefresh } from "vant";
import "@vant/touch-emulator";
import { SwipeCell } from "vant";
import { Overlay } from "vant";
import { NumberKeyboard } from "vant";
import { ImagePreview } from "vant";
import { Picker } from "vant";
import { Notify } from "vant";

// 全局注册
Vue.use(Notify);
Vue.use(Picker);
Vue.use(ImagePreview);
Vue.use(NumberKeyboard);
Vue.use(Overlay);
Vue.use(SwipeCell);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Field);
Vue.config.productionTip = false;

import VConsole from "vconsole";
if (process.env.VUE_APP_VCONSOLE == "true") {
  // new VConsole();
}

// 字体文件
import "./common/font/font.css";
// 全局rem
import "./common/js/rem";
// vuex
import store from "./store/index.js";
import utils from "./utils/index.js";
Vue.use(utils);

import FastClick from "fastclick";
FastClick.attach(document.body);
const str = navigator.userAgent.toLowerCase();
const ver = str.match(/cpu iphone os (.*?) like mac os/);

FastClick.prototype.focus = function (targetElement) {
  targetElement.focus();
};

if (!ver) {
  //非IOS系统
  // 引入fastclick 做相关处理
  FastClick.attach(document.body);
} else {
  if (parseInt(ver[1]) < 11) {
    // 引入fastclick 做相关处理
    FastClick.attach(document.body);
  }
}

import components from "@/plugins/components.js";
Vue.use(components);

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
